<template>
  <div id="app">
    <v-main>
      <Upper />
      <router-view />
      <DialogDevice />
    </v-main>
  </div>
</template>

<script>
import DialogDevice from '../Lobby/dialog/dialogDevice.vue'
import Upper from '../upper'
export default {
  components: { Upper, DialogDevice }
}
</script>

<style scoped>
</style>
